/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmUserauthV1ProgramQueryServiceProgramListProgramListRequest, IxmUserauthV1ProgramQueryServiceProgramListResponse } from '@interxfi/types';

export const IXM_USERAUTH_V1_PROGRAM_QUERY_SERVICE_PROGRAM_LIST_AUDIENCE = ['platform', 'organization', 'clearing', 'program'];

export async function ixmUserauthV1ProgramQueryServiceProgramList(baseUrl: string | undefined, request?: IxmUserauthV1ProgramQueryServiceProgramListProgramListRequest, requestInit?: RequestInit): Promise<IxmUserauthV1ProgramQueryServiceProgramListResponse | undefined> { return makeRequest<IxmUserauthV1ProgramQueryServiceProgramListResponse, IxmUserauthV1ProgramQueryServiceProgramListProgramListRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/portal/userauth/v1/program/q', request, requestInit)); }

